<avla-toast [view]="viewToast" [message]="messageToast"></avla-toast>
<router-outlet></router-outlet>
